import styled from 'styled-components';
import { IButtonProps } from './button-types';
import { Button } from './button-base';
import { buttonStyleGenerator } from './button-style-generator';

export interface IDefaultButtonProps extends Omit<IButtonProps, 'outline'> { }

export const DefaultButton = styled(Button)`
    ${buttonStyleGenerator('default')};
`;
